export default "__VITE_PUBLIC_ASSET__40184b7a__"